import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardEmployeeDocumentUX = (props: any) => {
    return(
      <div
        id="ModEditDiscountUX-div-0"
        style={{padding: "10px", display: "grid", gridTemplateColumns: "45rem 1fr", marginTop: "-1.45rem"}}>
        <div
          id="CardEmployeeDocumentUX-div-1"
          style={{borderRight: "1px solid rgba(188, 188, 188, 1)", paddingRight: "1rem", paddingTop: "1rem"}}>

          <Form
            id="CardEmployeeDocumentUX-Form-3">
            <FormGroup
              id="CardEmployeeDocumentUX-FormGroup-4"
              inline={true}
              style={{display:props.readOnly?"none":""}}>
              <FormField
                id="CardEmployeeDocumentUX-FormField-5"
                inline={true}
                width={16}>
                <label
                  id="CardEmployeeDocumentUX-label-8"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  Select Document name
                </label>
                <Dropdown
                  fluid={true}
                  id="CardEmployeeDocumentUX-Dropdown-9"
                  loading={props.isDocLoading??false}
                  onChange={props.onChangeDocumentType}
                  options={props.documentTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.documentType ?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardEmployeeDocumentUX-FormField-6"
                inline={true}>
                <div
                  id="CardEmployeeDocumentUX-div-7">
                  {props.buttonUpload}
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardEmployeeDocumentUX-div-10"
            style={{width: "100%"}}>

            <Table
              data={props.tableData}
              getTrProps={props.getTrProps}
              headers={props.headers}
              id="CardEmployeeDocumentUX-Table-11"
              keys="document_name,file_name,upload_date,action"
              minRows={13}
              showPagination={false}
              sortable={false}
              style={{height: props.readOnly?"calc(-9rem + 100vh)":"calc(-13rem + 100vh)"}}
              widths="^100,200,100,80">
            </Table>
          </div>
        </div>
        <div
          id="CardEmployeeDocumentUX-div-2"
          style={{paddingLeft: "1rem"}}>
          {props.documentViewer}
        </div>
      </div>
    )
}


export default CardEmployeeDocumentUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Sat Jul 19 2025 18:48:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModEditDiscountUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", display: \"grid\", gridTemplateColumns: \"45rem 1fr\", marginTop: \"-1.45rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{borderRight: \"1px solid rgba(188, 188, 188, 1)\", paddingRight: \"1rem\", paddingTop: \"1rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.documentViewer"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-Form-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display:props.readOnly?\"none\":\"\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUpload"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Select Document name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-Dropdown-9"
        },
        "loading": {
          "type": "code",
          "value": "props.isDocLoading??false"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDocumentType"
        },
        "options": {
          "type": "code",
          "value": "props.documentTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.documentType ?? \"\""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 11,
      "name": "Table",
      "parent": 10,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.headers"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeDocumentUX-Table-11"
        },
        "keys": {
          "type": "value",
          "value": "document_name,file_name,upload_date,action"
        },
        "minRows": {
          "type": "code",
          "value": "13"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.readOnly?\"calc(-9rem + 100vh)\":\"calc(-13rem + 100vh)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^100,200,100,80"
        }
      },
      "seq": 11,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeDocumentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
